var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.042 22.824C21.6527 22.824 23.0207 22.2613 24.146 21.136C25.2707 20.0113 25.833 18.6433 25.833 17.032C25.833 15.4213 25.2707 14.0603 24.146 12.949C23.0207 11.8376 21.6527 11.282 20.042 11.282C18.4307 11.282 17.0693 11.8376 15.958 12.949C14.8473 14.0603 14.292 15.4213 14.292 17.032C14.292 18.6433 14.8473 20.0113 15.958 21.136C17.0693 22.2613 18.4307 22.824 20.042 22.824ZM7.792 35.074C7.042 35.074 6.389 34.7963 5.833 34.241C5.27767 33.685 5 33.032 5 32.282V7.86597C5 7.11597 5.27767 6.46297 5.833 5.90697C6.389 5.35164 7.042 5.07397 7.792 5.07397H32.208C32.958 5.07397 33.611 5.35164 34.167 5.90697C34.7223 6.46297 35 7.11597 35 7.86597V32.282C35 33.032 34.7223 33.685 34.167 34.241C33.611 34.7963 32.958 35.074 32.208 35.074H7.792ZM7.792 32.282H32.208V30.616C30.5973 29.088 28.7573 27.8656 26.688 26.949C24.618 26.0323 22.3887 25.574 20 25.574C17.6113 25.574 15.382 26.0323 13.312 26.949C11.2427 27.8656 9.40267 29.088 7.792 30.616V32.282Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBox);
export default __webpack_public_path__ + "static/media/account-box.ef1707c9d9d5f7940f24b06902d97f46.svg";
export { ForwardRef as ReactComponent };